var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgBankCard(props) {
    return (React.createElement("svg", __assign({ viewBox: '-1 0 49 30' }, props),
        React.createElement("g", { fillRule: 'evenodd' },
            React.createElement("path", { d: 'M45.64 0c.707 0 1.288.569 1.354 1.296l.006.138v28.133c0 .745-.54 1.357-1.23 1.426l-.13.007H1.36c-.707 0-1.288-.568-1.354-1.295L0 29.567V1.434C0 .688.54.076 1.23.007L1.36 0h44.28zm-1.885 2H3.245C2.557 2 2 2.559 2 3.249v24.503C2 28.442 2.557 29 3.245 29h40.51c.688 0 1.245-.559 1.245-1.248V3.249C45 2.559 44.443 2 43.755 2z' }),
            React.createElement("path", { d: 'M12.415 5.25c1.236 0 2.247.96 2.33 2.175l.005.16v4.83c0 1.236-.96 2.247-2.175 2.33l-.16.005h-4.83a2.336 2.336 0 01-2.33-2.176l-.005-.16V7.585c0-1.236.96-2.247 2.176-2.33l.16-.005h4.829zM11.81 7H8.19a1.19 1.19 0 00-1.183 1.067L7 8.19v3.622a1.19 1.19 0 001.068 1.183l.121.006h3.622a1.19 1.19 0 001.183-1.068l.006-.121V8.189a1.19 1.19 0 00-1.067-1.183L11.81 7zM6 22h34a1 1 0 010 2H6a1 1 0 010-2z' }))));
}
export default SvgBankCard;
//# sourceMappingURL=BankCard.js.map